const useExtraRules = () => {
  return {
    disabledPtiaVersementRenteTTCause: false,
    disabledPtiaVersementRenteAcc: false,
    disabledPtiaVersementCapitalAcc: false
  };
};

export default useExtraRules;
